const dollarFormatter = (value, includeCentDigits) => {
  const roundDigits = includeCentDigits ? 2 : 0;
  if (value < 0) {
    return `-$${Math.abs(value).toFixed(roundDigits)}`;
  }
  return `$${value.toFixed(roundDigits)}`;
};

export default dollarFormatter;
